import { render } from "./TempatTinggal.vue?vue&type=template&id=8c0ef5fe"
import script from "./TempatTinggal.vue?vue&type=script&lang=js"
export * from "./TempatTinggal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__